import { http } from "../client";
export var uploadZip = function (_a) {
    var file = _a.file, metadata_source = _a.metadata_source, artist_title_filename_separator = _a.artist_title_filename_separator;
    var formData = new FormData();
    formData.append("file", file);
    formData.append("metadata_source", metadata_source);
    formData.append("artist_title_filename_separator", artist_title_filename_separator);
    return http.api
        .post("tracks/zip", formData)
        .then(function (response) { return ({ tracks: response.data.data.tracks }); })
        .catch(function (error) { return Promise.reject(error); });
};
